
export const IDS = {
  // Task List IDs
  TASK_LIST: {
    BOOKING: "c96b91ab-7662-4533-8172-5e1e387ea918", // Used in TaskService for deleteBookingTask
    CALLBACK_REQUEST: "58b2b027-55b5-49cc-849c-f4c0a82c0883", // Used in CallbackRequestModal
    PICKUP: "91f8ce7c-d18c-4ba9-8f54-8c645979ac73", // Used in PickUp component
  },

  // Assessment IDs
  ASSESSMENT: {
    MAIN: "7e458dc9-23e2-4645-8e17-934e2d61a4fd",
  },

  // Template IDs
  TEMPLATES: {
    CUSTOMER: "f9466b6c-80ee-4db1-8099-5bcf2a0ea1db",
    ADMIN: "1fb65ba5-ddb5-47bf-8585-0dc55ca8c943",
    FEEDBACK: "69e5f558-35cb-4b54-87a9-b171a4a2caac",
  },

  // Booking IDs
  BOOKING: {
    REPAIR_CALENDAR: "4e4e14c7-45c7-4f54-8724-2a30aac8e61d",
    DEFAULT_SMS: "2d86f2dd-c7ea-4f6a-85a2-4968140f588a",
    DEFAULT_EMAIL: "40f154f5-4321-4fa9-8815-6e31d4ba6f26",
    INSPECTION_SMS: "f920750d-42d2-4e7f-8663-ed5b2da9c6e2",
    INSPECTION_EMAIL: "153440a5-d1ea-4e04-83b8-c0dd81a60c78",
  },

  // Service IDs
  SERVICES: {
    REDEEM_DEBTOR: "26554869-8bec-4cde-8206-e9313e6f16a7",
    LOAN_CAR: "486de059-b439-4796-9a20-23512e4d33cd",
    BUDGET_REVISION: "c2990410-098f-5981-8eac-bab2659f4c4c",
  },

  // Profile IDs
  PROFILES: {
    ESTIMATE: "88f194c9-ad9b-4c93-8f31-73c10a627411",
  },

  // IBS Service IDs
  IBS: {
    TASK_ADD: "79604011-937f-44b1-95e5-404f3a5be4c8",
    NOTIFICATION: "6e69bb43-fb35-4f01-8fd3-505b4cb861e7",
  },

  // Special Values
  SPECIAL: {
    EMPTY_UUID: "00000000-0000-0000-0000-000000000000",
  },
} as const;

// Type for all IDs
export type IdType = typeof IDS[keyof typeof IDS];

// Helper functions for specific ID categories
export const getTaskListIds = () => Object.values(IDS.TASK_LIST);
export const getTemplateIds = () => Object.values(IDS.TEMPLATES);
export const getBookingIds = () => Object.values(IDS.BOOKING);
export const getServiceIds = () => Object.values(IDS.SERVICES); 